import type { UserFileRead } from '@/uppy-file-upload/schemas'
import { store } from '@/store/store'
import { selectFilesById } from '@/user_files/files/store/selectors'
import { fetchAndStoreUserFiles } from './fetch-and-store-user-files'

/**
 * Resolve a single user-file record by id from outside React, store-first: return the cached record
 * if present (the viewer / file lists almost always loaded it) and only fetch when it's missing.
 * The cache-first counterpart to `fetchAndStoreUserFiles`; inside React, use the `useUserFile` hook.
 */
export async function resolveUserFile(userFileId: string): Promise<UserFileRead | undefined> {
  return selectFilesById(store.getState())[userFileId] ?? (await fetchAndStoreUserFiles([userFileId], store.dispatch))[userFileId]
}
